import React, { Component } from 'react';

import Notification from '../../Components/Notification/Notification';
import PersonalDetailsForm from '../../Components/PersonalDetailsForm/PersonalDetailsForm';
import Logic from '../../Logic';

class Edit extends Component {
    constructor(props) {
        super(props);
        this.logic = new Logic();
        this.state = {candidate: null, notificationSuccess: false, notificationMessage: null };
        this.onFormSubmitted = this.onFormSubmitted.bind(this);
    }

    async onFormSubmitted(values, step){
        this.props.toggleSpinner();
        try {
            var res = await this.logic.saveForm(values, step).then(response => {
                this.props.notify(response.success, response.message);
                if(response.success){
                    this.setState({candidate: response.data.candidate});
                }
                this.props.toggleSpinner();
                return response; //return resolved;
            });
        } catch (error) {
            console.log(error);
            this.props.toggleSpinner();
            alert('אירעה שגיאה בעת שמירת הטופס.');
        }
        return res; //return promise
    }

    componentDidMount(){
        if(this.props.match){
            const {authKey} = this.props.match.params;
            if(authKey){ //in case of double click on candidates table
                this.logic.getCandidateByAuthKey(authKey, (data) => {
                    this.setState({candidate:data});
                });
            }else if(this.props.init.candidate){ //in case of self service candidate or simulation
                this.setState({candidate: this.props.init.candidate});
            }
        }
    }

    render(){
        this.showEditForm = this.state.candidate && this.state.candidate.authKey.length > 0;

        return (
            <div>
                {this.showEditForm ? //edit existing candidate if candidate is logged in or user passed candidate object and fill by him
                <PersonalDetailsForm formTitle={'עריכת פרטי מועמד'} candidate={this.state.candidate} onFormSubmitted={this.onFormSubmitted} init={this.props.init} {...this.props}/>
                : null}
            </div>
        );
    }
  };
  
export default Edit;